import { Component, EventEmitter, Input, Output } from '@angular/core';
import { projectIconDataMap } from 'src/app/shared/helpers/projects.helper';
import { Technology } from 'src/app/shared/model/general/Technology';
import { IStateType } from './shared/models/state-type.interface';

@Component({
  selector: 'digires-type-filtering-button',
  templateUrl: './type-filtering-button.component.html',
  styleUrls: ['./type-filtering-button.component.scss']
})
export class TypeFilteringButtonComponent {
  @Input() type: Technology;
  @Input() set isActive (isActive: boolean[]) {
    this.isActiveValue = isActive[0];
  }

  @Output() changeState: EventEmitter<IStateType> = new EventEmitter();

  isActiveValue: boolean = true;
  projectIconDataMap = projectIconDataMap;

  manualToggleState () {
    this.isActiveValue = !this.isActiveValue;
    this.changeState.emit({
      state: this.isActiveValue,
      type: this.type
    });
  }
}
